import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer, useRelationshipDiscoverer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useLoadOne } from 'src/mtska-frontend-data-provider/hooks/useLoadOne.hooks';

const dataProviderName = 'campaigns/campaignactivity'
const model = 'campaigns/campaign'
const wizardName = 'Campaign Activity Outcome';
const wizardObject = 'CampaignActivity';
const wizardAction = 'leadOutcome';

const CampaignActivityCreate = (params) => {
    const { t } = useTranslation();
    const { userCapabilities, existingModules } = useContext(AppContext);
    const [drawable, setDrawable] = useState(false);
    const { doAction, item, loadOne, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart);
    const { item: campaignlead, loadOne: loadOneCampaignLead } = useDataProvider('campaigns/campaignlead');

    useLoadOne({ loadOne, params })

    const { detailConfig } = existingModules[dataProviderName];

    const [editing, setEditing] = useState(false)

    useEffect(() => {
        if (success && editing) {
            (async () => {
                try {
                    // svuoto la selezione del drawer padre per evitare riassegnazioni
                    params.setSelected && params.setSelected([]);

                    await params.handleClose(params.uid, item.data)
                } catch (e) { }
            })()
        }
    }, [success])


    useEffect(() => {
        loadOneCampaignLead(params.id).then(() => setDrawable(true));
    }, [])

    const handleSave = async (data) => {
        doAction && doAction({ action: wizardAction, model: dataProviderName, data: {
            campaignLeadId: data?.campaignlead?.data?._original_id,
            outcomeId: data?.selected,
            notes: data?.notes
        }});
    }

    return (
        drawable &&
        <>
            <DetailComponent
                values={{
                    ...item?.data,
                    campaignlead: campaignlead
                }}
                modelName={model.split('/')[1]}
                detailConfig={detailConfig}
                dataProviderName={dataProviderName}
                onEditing={setEditing}
                save={handleSave}
                saving={saving}
                errors={errors}
                editing={true}
                errorMessage={errorMessage}
                title={t(wizardName)}
                canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
                header={
                    <InfoHeader
                        view="campaignleadoperator"
                        item={campaignlead?.data}
                    />
                }
                {...params}
            />
        </>
    )
}

export default CampaignActivityCreate;